export interface DidYouKnowTip {
  textKey: string;
  helpUrl: string;
}

const ADVISOR_HELP_BASE_URL =
  'https://wahelp.helpdocsonline.com/ejo2yu5vgt062pqu4ud9mk5h7v0wqi06';

export const ADVISOR_DID_YOU_KNOW_TIPS: DidYouKnowTip[] = [
  {
    textKey: 'advisorQuickLinks.tipAccountGroups',
    helpUrl: `${ADVISOR_HELP_BASE_URL}#setup/accountgroups`,
  },
  {
    textKey: 'advisorQuickLinks.tipContactInfo',
    helpUrl: `${ADVISOR_HELP_BASE_URL}#setup/contactInfo`,
  },
  {
    textKey: 'advisorQuickLinks.tipDefaultDashboard',
    helpUrl: `${ADVISOR_HELP_BASE_URL}#/default-dashboard`,
  },
];
